import sendRequest from "@/libs/sendRequest";

export const cpl = {
    namespaced: true,
    state: {
        data: [],
        total_data: 0,
    },
    getters: {
        getItems: (state) => state.data,
        getTotal: (state) => state.total_data,
    },
    mutations: {
        setItems: (state, payload) => {
            state.data = payload; 
        },
        setTotalItems: (state, payload) => {
            state.total_data = payload; 
        },
    },
    actions: {
        list: async ({ commit, rootGetters }, { page = 1, rows = 10, search = '', order_by = 'Id', order_asc = true }) => {
            const custom_headers = rootGetters.getHeaders;

            try {
                let query = { isDatatable: true, page, rows, search, order_by, order_asc }
                const response = await sendRequest(`administrator/heishop/cpl/list`, 'GET', null, null, query, custom_headers);

                if(response.data) {
                    commit('setItems', response.data.list.result); 
                    commit('setTotalItems', response.data.list.total_rows);
                } 
                else {
                    console.error('Error al cargar los datos:', response.errors);
                }
            } 
            catch (error) {
                console.error('Error en la solicitud:', error);
            }
        },
        add: async ({ dispatch, rootGetters }, { data }) => {
            const custom_headers = rootGetters.getHeaders; 
            try {
                const response = await sendRequest(`administrator/heishop/cpl/add`, 'POST', null, data, null, custom_headers);

                if(response.success) {
                    dispatch('showAlert', 'CPL agregados correctamente', { root: true })
                    // await dispatch('list'); 
                    return response;
                } 
                else {
                    dispatch('showError', response.errors ? response.errors[0].message : 'Ocurrio un error inesperado', { root: true })
                }
            } 
            catch (error) {
                console.error('Error al agregar el registro:', error);

                dispatch('showError', 'Error desconocido', { root: true })
            }
        }
    },
};